module.exports = __webpack_public_path__ + "static/img/Nipic_12106414_20160922174257880038.ed787c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/Nipic_12106414_20160922174257880038.png
// module id = 8LNO
// module chunks = 1